module.exports = __webpack_public_path__ + "static/media/planning-journal-image.fd71bd0d.png";